import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { fetchEntraUsers } from '../../services/BasicDetailsAPI'
import './PeoplePicker.scss';
import { FormikProps } from 'formik';

interface Person {
    displayName: string;
    mail: string;
}
interface PeoplePickerProps {
    name: string;
    formik: FormikProps<any>;
}
const PeoplePicker: React.FC<PeoplePickerProps> = ({ formik, name }) => {
    const [defaultOptions, setDefaultOptions] = React.useState<any[]>([]);

    useEffect(() => {
        const fetchDefault = async () => {
            const response = await fetchEntraUsers("");
            const options = response.data.result?.value.map((user: Person) => ({
                value: user.mail,
                label: user.displayName
            }));
            setDefaultOptions(options);
        };
        fetchDefault();
    }, []);

    const loadOptions = async (inputValue: string) => {
        if (!inputValue.trim()) return [];
        const users = await fetchEntraUsers(inputValue);
        return users.data.result.value.map((user: Person) => ({
            value: user.mail,
            label: user.displayName
        }));
    };

    const handleChange = (selectedOptions: any) => {
        const formattedString = selectedOptions
            ?.map((option: any) => `${option.label}:${option.value}`)
            .join(";") || "";
        formik.setFieldValue(name, formattedString);
    };

    const parseValue = () => {
        const valueString = formik.values[name];
        if (typeof valueString !== "string" || !valueString.trim()) return [];
        return valueString.split(";").map((entry: string) => {
            const [displayName, mail] = entry.trim().split(":");
            return { value: mail, label: displayName };
        });
    };

    const formatOptionLabel = ({ label }: any) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="grey" className="bi bi-person-circle" viewBox="0 0 16 16" style={{ marginRight: '8px', flexShrink: '0' }}>
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
            </svg>
            <span>{label}</span>
        </div>
    );

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            minHeight: '44px',
            height: 'auto',
            flexWrap: 'wrap',
            overflowY: 'auto',
            maxHeight: '80px',
        }),
        placeholder: (provided: any) => ({
            ...provided,
            textAlign: 'left',
            marginLeft: '5px',
        }),
        menu: (provided: any) => ({
            ...provided,
            textAlign: 'left',
        }),
        option: (provided: any) => ({
            ...provided,
            textAlign: 'left',
            cursor: 'pointer'
        }),
        clearIndicator: (provided: any) => ({
            ...provided,
            cursor: 'pointer',
        }),
    };
    return (
        <div>
            <label className="people-label" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                Negotiation Team
                <AsyncSelect
                    className="PeoplePicker-container"
                    styles={customStyles}
                    loadOptions={loadOptions}
                    defaultOptions={defaultOptions}
                    isMulti
                    placeholder='Search...'
                    onChange={handleChange}
                    formatOptionLabel={formatOptionLabel}
                    value={parseValue()}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null
                    }}
                    menuPosition="fixed"
                />
            </label>

        </div>
    );
};

export default PeoplePicker;

